/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/prop-types */
/* eslint-disable prefer-arrow-callback */
/* eslint-disable import/prefer-default-export */

import clsx from 'clsx'
import React, { useRef, forwardRef } from 'react'

import s from './Video.module.css'

export const Video = forwardRef(function Video(
  { src, className, videoClassname, videoProps, interactive = false, type = 'video/mp4' },
  ref
) {
  const video = useRef(null)

  return (
    <div ref={ref} className={clsx(s.root, className)}>
      <video
        aria-label="Video"
        ref={video}
        controls={false}
        autoPlay
        muted
        playsInline
        onMouseEnter={interactive ? () => video.current?.play() : () => null}
        onMouseLeave={interactive ? () => video.current?.pause() : () => null}
        className={clsx(s.video, videoClassname)}
        preload="none"
        {...{
          ...videoProps,
          loop: true,
        }}
      >
        <source src={src} type={type} />
        Your browser does not support the video tag.
      </video>
    </div>
  )
})
